function Input({ type, placeholder }) {
  return (
    <input
      className=" max-w-[400px] placeholder-blue text-2xl	font-medium	 outline-none w-full mb-4 px-3.5 py-4  rounded-[15px] border-2 border-blue text-blue"
      type={type}
      placeholder={placeholder}
    />
  );
}

export default Input;
